"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePhoneStyles = exports.useHeaderStyles = exports.useButtonStyles = void 0;
var _styles = require("@material-ui/core/styles");
const useHeaderStyles = (0, _styles.makeStyles)(theme => ({
  header: {
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 10,
    transitionProperty: "top",
    transitionDuration: "2s"
  },
  headerBackground: {
    backgroundColor: props => props.backgroundColor
  },
  headerStatic: {
    top: "-400px"
  },
  headerShadow: {
    boxShadow: "-1px 2px 4px 0px rgba(0, 0, 0, 0.05)"
  },
  container: {
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "64px",
    minHeight: "64px",
    [theme.breakpoints.up("md")]: {
      height: "88px",
      minHeight: "88px"
    },
    "& img": {
      verticalAlign: "top"
    }
  },
  rightBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }
}));
exports.useHeaderStyles = useHeaderStyles;
const usePhoneStyles = (0, _styles.makeStyles)(theme => ({
  phoneContainer: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex ",
      gap: 3,
      alignItems: "flex-start",
      flexDirection: "column",
      "& a": {
        fontSize: "22px",
        color: "rgba(96, 114, 137, 1)"
      },
      "& p": {
        letterSpacing: "normal",
        fontSize: "12px",
        color: "rgba(96, 114, 137, 1)"
      },
      marginRight: "40px"
    }
  },
  phoneContainerAB: {
    display: "flex ",
    gap: 3,
    alignItems: "flex-end",
    flexDirection: "column",
    "& a": {
      fontSize: "16px",
      color: "rgba(96, 114, 137, 1)"
    },
    "& p": {
      letterSpacing: "normal",
      fontSize: "10px",
      color: "rgba(96, 114, 137, 1)"
    },
    [theme.breakpoints.up("sm")]: {
      "& a": {
        fontSize: "22px"
      },
      "& p": {
        fontSize: "12px"
      }
    },
    [theme.breakpoints.up("md")]: {
      alignItems: "flex-start"
    }
  },
  phoneMultiple: {
    marginBottom: 4,
    fontSize: 16,
    lineHeight: "16px",
    [theme.breakpoints.up("md")]: {
      fontSize: 20,
      lineHeight: "20px"
    }
  },
  phoneNum: {
    fontWeight: 500,
    fontSize: 20,
    color: "#607289",
    textDecoration: "none",
    lineHeight: "22px",
    display: "block",
    [theme.breakpoints.up("md")]: {
      fontSize: 23
    }
  },
  phoneHint: {
    margin: 0,
    fontSize: 9,
    fontWeight: 400,
    lineHeight: "12px",
    letterSpacing: "0.05px",
    [theme.breakpoints.up("md")]: {
      letterSpacing: "0.2px",
      fontSize: 10
    }
  }
}));
exports.usePhoneStyles = usePhoneStyles;
const useButtonStyles = (0, _styles.makeStyles)({
  root: {
    padding: "8px 20px",
    maxHeight: 36
  },
  label: {
    fontSize: 16,
    lineHeight: "20px"
  }
}); // export default useStyles;

exports.useButtonStyles = useButtonStyles;